<template>
  <footer>
    <div class="footer-content">
      <p class="company-name">MAGICUBE GROUP CO., LIMITED</p>
      <p class="company-address">
        RM 1801 EASEY COMM BLDG 253-261 HENNESSY ROAD WANCHAI HK.
      </p>
      <p class="copyright">
        {{ $t('copyright') }}
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterCom',
}
</script>

<style lang="scss" scoped>
footer {
  background-color: #111111;
  .footer-content {
    padding: 49px 0;
    max-width: 1000px;
    margin: 0 auto;
    .company-name,
    .company-address,
    .copyright {
      color: #fff;
      text-align: center;
    }
    .company-name {
      font-weight: bold;
      margin-bottom: 8px;
    }
    .company-address {
      margin-bottom: 8px;
    }
  }
}
</style>
